(function() {
    'use strict';
    angular
        .module('doctorclubboApp')
        .factory('Fee_agenzia', Fee_agenzia);

    Fee_agenzia.$inject = ['$resource'];

    function Fee_agenzia ($resource) {
        var resourceUrl =  'api/fee-agenzias/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
